import React from 'react';
import { MatrixBackground } from '../components/MatrixBackground';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { CredibilityBar } from '../components/CredibilityBar';
import { ProblemSection } from '../components/ProblemSection';
import { OpportunitySection } from '../components/OpportunitySection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { ProofSection } from '../components/ProofSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
import { FinalClose } from '../components/FinalClose';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
import { LanguageSelector } from '../components/LanguageSelector';
import { useLanguage } from '../context/LanguageContext';
export function SalesPage() {
  const {
    showLanguageSelector,
    handleLanguageSelection
  } = useLanguage();
  return <div className="w-full bg-gradient-to-b from-black via-teal-950 to-black text-white" data-id="element-489">
      <MatrixBackground data-id="element-490" />
      <SalesNotification data-id="element-491" />
      {showLanguageSelector && <LanguageSelector onSelectLanguage={handleLanguageSelection} data-id="element-492" />}
      <div className="relative z-10" data-id="element-493">
        <HeroSection data-id="element-494" />
        <OpeningHook data-id="element-495" />
        <CredibilityBar data-id="element-496" />
        <ProblemSection data-id="element-497" />
        <OpportunitySection data-id="element-498" />
        <StorySection data-id="element-499" />
        <SolutionSection data-id="element-500" />
        <ProofSection data-id="element-501" />
        <WhatYouGetSection data-id="element-502" />
        <GuaranteeSection data-id="element-503" />
        <UrgencySection data-id="element-504" />
        <FinalCTA data-id="element-505" />
        <FAQSection data-id="element-506" />
        <FinalClose data-id="element-507" />
        <Footer data-id="element-508" />
      </div>
    </div>;
}